import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const ORIGIN = "https://www.looxsfashion.com";

/**
 * Per-page metadata for LOOXS. Renders <title>, meta description, canonical link,
 * OpenGraph and Twitter cards for the current route. Pass overrides via props.
 */
export default function PageMeta({
  title,
  description,
  image = `${ORIGIN}/api/static/brand/looxs-emblem.png`,
  canonical,
  type = "website",
  noIndex = false,
}) {
  const location = useLocation();
  const url = canonical || `${ORIGIN}${location.pathname}`;
  const t = title
    ? `${title} · LOOXS`
    : "LOOXS — Contemporary Luxury Fashion · Designed in London, Crafted in India";
  const d = description || (
    "LOOXS is a private universe of contemporary luxury structured across eleven chapters. " +
    "Designed in London, crafted in India — for the individual who dresses with intent."
  );
  return (
    <Helmet prioritizeSeoTags>
      <title>{t}</title>
      <meta name="description" content={d} />
      <link rel="canonical" href={url} />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="LOOXS" />
      <meta property="og:title" content={t} />
      <meta property="og:description" content={d} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={t} />
      <meta name="twitter:description" content={d} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
